import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { Tabs ,Modal} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

const { TabPane } = Tabs;

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			auth_token:''
		}
		this.logout = this.logout.bind(this);
	}

	componentWillMount() {
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		window.location.href = '/login';
	}
	
	
	logout(){
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		window.location.href = '/login/';
	}

	render() {
	
	const { visible, loading } = this.state;	
		return (
			<>
			
			
			</>
		) 
	} 
}
export default Index;
